import * as React from 'react';
const DigestioneLentaEDifficileIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M130.76 58.47c0 10.77-4.61 21.4-4.61 29.22 0 12.95 10.77 17.43 10.77 53.83M69.24 58.47c0 10.77 4.61 21.4 4.61 29.22 0 12.95-10.77 17.43-10.77 53.83"
      className="prefix__cls-2"
    />
    <path
      d="M70.78 70.78c9.75 0 23.45-4.62 29.22-4.62s19.47 4.62 29.22 4.62M64.16 124.61s18.19 4.61 35.84 4.61 35.84-4.61 35.84-4.61"
      className="prefix__cls-2"
    />
    <path
      d="M86.71 92.25c2.68-4.57 7.63-7.63 13.29-7.63 8.49 0 15.38 6.89 15.38 15.38 0 .96-.09 1.91-.26 2.81M84.88 97.19c-.17.91-.26 1.85-.26 2.81 0 8.49 6.89 15.38 15.38 15.38 5.61 0 10.54-3.01 13.21-7.5"
      className="prefix__cls-1"
    />
    <path
      d="m121.53 96.92-6.15 6.16-6.15-6.16M78.47 103.08l6.15-6.16 6.15 6.16"
      className="prefix__cls-1"
    />
  </svg>
);
export default DigestioneLentaEDifficileIcon;
